import * as React from 'react';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';

export default function SelectAutoWidth(props) {
    const [dispositivoSeleccionado, setDispositivoSeleccionado] = React.useState('-1');
    const [microfonos, setMicrofonos] = React.useState([]);
    const [camaras, setCamaras] = React.useState([]);

    async function getMicrofonos() {
      try {
        // Pedir permiso al usuario para acceder a los dispositivos multimedia
        await navigator.mediaDevices.getUserMedia({ audio: true });
        
        // Obtener la lista de dispositivos multimedia
        const devices = await navigator.mediaDevices.enumerateDevices();

        // Filtrar solo los dispositivos de tipo "audioinput" (micrófonos)
        const audioDevices = devices.filter(device => device.kind === 'audioinput');
        console.log(audioDevices);
        if (audioDevices.length > 0) {
          setDispositivoSeleccionado(audioDevices[0].deviceId);
        } else {
          setDispositivoSeleccionado("-1");
        }
        setMicrofonos(audioDevices);
      } catch (err) {
        console.error('Error al acceder a los dispositivos de audio:', err);
        // Mostrar error.
      }
    }

    async function getCamaras() {
      try {
        // Pedir permiso al usuario para acceder a los dispositivos multimedia
        await navigator.mediaDevices.getUserMedia({ video: true });
        
        // Obtener la lista de dispositivos multimedia
        const devices = await navigator.mediaDevices.enumerateDevices();

        // Filtrar solo los dispositivos de tipo "videoinput" (cámaras)
        const videoDevices = devices.filter(device => device.kind === 'videoinput');
        console.log(videoDevices);
        if (videoDevices.length > 0) {
          setDispositivoSeleccionado(videoDevices[0].deviceId);
        } else {
          setDispositivoSeleccionado("-1");
        }
        setCamaras(videoDevices);
      } catch (err) {
        console.error('Error al acceder a los dispositivos de video:', err);
        // Mostrar error.
      }
    }

    React.useEffect(() => {
      const init = async () => {
        console.log("init");
        if (props.tipo === "microfono") {
          getMicrofonos();
        } else {
          getCamaras();
        }
      }
      init();
    }, []);
  
    const handleChange = (event) => {
      setDispositivoSeleccionado(event.target.value);
    };
  
    return (
      <div>
        <label className='select-device-label'>{ props.etiqueta }</label>
        <FormControl sx={{ m: 1, minWidth: 240 }} style={{ verticalAlign: "middle" }}>
          <InputLabel id="demo-simple-select-autowidth-label">Seleccione</InputLabel>
          <Select
            labelId="select-dispositivo-label"
            id="select-dispositivo"
            value={dispositivoSeleccionado}
            onChange={handleChange}
            autoWidth
            label="Dispositivo"
          >
            { props.tipo === "microfono" ? (
              microfonos.length > 0 ? (
                microfonos.map((value, index) => (
                  <MenuItem key={value.deviceId} value={value.deviceId}>{value.label}</MenuItem>
                ))
              ) : (
                <MenuItem key="-1" value="-1">Sin micrófono detectado</MenuItem>
              )
            ):(
              camaras.length > 0 ? (
                camaras.map((value, index) => (
                  <MenuItem key={value.deviceId}value={value.deviceId}>{value.label}</MenuItem>
                ))
              ) : (
                <MenuItem key="-1" value="-1">Sin cámara detectada</MenuItem>
              )
            )}
          </Select>
        </FormControl>
      </div>
    );
  }